import { css } from '@emotion/react';
import { breakpoints } from '../../styles';
import { PrimaryProps, p2r } from '../../styles/fonts';

const styles = ({ width, maxWidth, color, fontSize = 18, padding, fontWeight = 300, lineHeight = 28 }) => css`
  width: ${width};
  max-width: ${maxWidth};
  ${PrimaryProps}
  .text {
    padding: ${padding};
    margin: 0;
    font-size: ${p2r(fontSize)};
    font-weight: ${fontWeight};
    line-height: ${p2r(lineHeight)};
    color: ${color};
  }

  @media (max-width: ${breakpoints.tablet}px) {
    width: 100%;
  }
`;

export default styles;
